/** A function type that filters values of type T. */
type FilterFunction<T> = (value: T) => boolean;
/** A function type that compares two values of the same type for equality. */
type IsEqualFunction<T> = (a: T, b: T) => boolean;

/** Checks if two values are strictly equal. */
const isStrictEqual = (a: unknown, b: unknown): boolean => a === b;

/**
 * Returns a filter function for Observable.filter that only passes values which have changed compared to the last value.
 *
 * @param isEqual Optional comparison function to determine if the current value is different from the previous value
 * @returns A filter function for Observable.filter
 */
export function distinctUntilChangedFilter<T>(isEqual: IsEqualFunction<T> = isStrictEqual): FilterFunction<T> {
    let previousValue: T | undefined = undefined;
    let isFirstValue = true;
    return (value: T) => {
        // check if it's the first value or different from the previous value
        if (isFirstValue || !isEqual(previousValue!, value)) {
            // update the flag after the first value
            isFirstValue = false;
            // update previous value for next comparison
            previousValue = value;
            // emit the current value
            return true;
        }
        // skip the current value
        return false;
    };
}
